<div class="background"></div>
<div class="content">
  <h2>{{ "ERRORS.oops" | translate }}</h2>
  <p>{{ "ERRORS.appError" | translate }}</p>
  <p>
    {{ "ERRORS.contactSupportPrefix" | translate }}
    <strong>{{ portalSupportEmail }}</strong>
    {{ "ERRORS.contactSupportSuffix" | translate }}
  </p>
  <button mat-raised-button (click)="navToSummary()">
    Go back to Summary Page
  </button>
</div>
